import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { categories, topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function TopicGrid() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(
    () => (active === "全部" ? topics : topics.filter((t) => t.category === active)),
    [active],
  );

  return (
    <section id="topics" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
            <span className="w-6 h-px bg-primary-500"></span>
            Topics
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            精选话题
          </h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base leading-7 text-foreground-600">
            按分类浏览近期热门内容，点击卡片右上角即可收藏、标记，加入你的回看清单。
          </p>
        </div>
        <Link
          to="/topics"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          进入话题库
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 flex flex-wrap gap-2">
        {categories.map((cat) => (
          <button
            key={cat.key}
            type="button"
            onClick={() => setActive(cat.key)}
            className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
              active === cat.key
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            <i className={cat.icon}></i>
            {cat.key}
          </button>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>

      {filtered.length === 0 && (
        <p className="mt-10 text-center text-sm text-foreground-500">该分类暂无话题，换个分类看看。</p>
      )}
    </section>
  );
}